<template>
    <aside class="glass-sidebar" :class="{ collapsed: sidebarCollapsed }">

        <!-- Brand Logo -->
        <div class="sidebar-brand" @click="goToDashboard" style="cursor: pointer; display: flex; align-items: center; gap: 12px; padding: 1rem 0.5rem 1.5rem 0.5rem;">
            <div class="logo-glow" style="display: grid; place-items: center; filter: drop-shadow(0 2px 6px rgba(26, 161, 126, 0.4));">
                <svg width="34" height="34" viewBox="0 0 48 48" fill="none">
                    <rect width="48" height="48" rx="12" fill="#0071C5" />
                    <path d="M24 12L32 20L24 28L16 20L24 12Z" fill="white" opacity="0.9" />
                    <path d="M24 20L32 28L24 36L16 28L24 20Z" fill="white" opacity="0.6" />
                </svg>
            </div>
            <span v-if="!sidebarCollapsed" class="brand-text-dark" style="font-family: var(--font-display); font-size: 1.1rem; font-weight: 700; color: #fff; letter-spacing: -0.02em;">INTELVO<span style="background: linear-gradient(135deg, #34f0c0 0%, #0ea5e9 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent;"> ADMIN</span></span>
        </div>

        <router-link to="/" class="sidebar-pill" exact-active-class="active">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="3" width="7" height="7" />
                <rect x="14" y="3" width="7" height="7" />
                <rect x="14" y="14" width="7" height="7" />
                <rect x="3" y="14" width="7" height="7" />
            </svg>
            <span v-if="!sidebarCollapsed">Dashboard</span>
        </router-link>

        <router-link to="/companies" class="sidebar-pill" active-class="active">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 21h18" />
                <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16" />
                <path d="M9 8h1" />
                <path d="M9 12h1" />
                <path d="M9 16h1" />
                <path d="M14 8h1" />
                <path d="M14 12h1" />
                <path d="M14 16h1" />
            </svg>
            <span v-if="!sidebarCollapsed">Companies</span>
        </router-link>

        <router-link to="/pdfs" class="sidebar-pill" active-class="active">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
            </svg>
            <span v-if="!sidebarCollapsed">PDF Audit</span>
        </router-link>

        <router-link to="/integrations" class="sidebar-pill" active-class="active">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </svg>
            <span v-if="!sidebarCollapsed">Integrations</span>
        </router-link>

        <router-link to="/plans" class="sidebar-pill" active-class="active">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
            <span v-if="!sidebarCollapsed">Plans & Pricing</span>
        </router-link>

        <router-link to="/payment-links" class="sidebar-pill" active-class="active">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
                <line x1="1" y1="10" x2="23" y2="10" />
            </svg>
            <span v-if="!sidebarCollapsed">Payment Links</span>
        </router-link>

        <router-link to="/api-keys" class="sidebar-pill" active-class="active">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.78 7.78 5.5 5.5 0 0 1 7.78-7.78zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
            </svg>
            <span v-if="!sidebarCollapsed">API Keys</span>
        </router-link>

        <div class="sidebar-spacer"></div>

        <!-- Bottom bar: logout + collapse toggle -->
        <div class="sidebar-bottom-bar">
            <div class="sidebar-pill logout-btn" @click="handleLogout">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                    <polyline points="16 17 21 12 16 7"></polyline>
                    <line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                <span v-if="!sidebarCollapsed">Logout</span>
            </div>

            <!-- Collapse toggle -->
            <button class="collapse-btn" @click="sidebarCollapsed = !sidebarCollapsed" :title="sidebarCollapsed ? 'Expand' : 'Collapse'">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline v-if="!sidebarCollapsed" points="15 18 9 12 15 6" />
                    <polyline v-else points="9 18 15 12 9 6" />
                </svg>
            </button>
        </div>
    </aside>
</template>

<script>
export default {
    name: 'SuperAdminSidebar',
    data() {
        return {
            sidebarCollapsed: false
        };
    },
    watch: {
        sidebarCollapsed(val) {
            document.documentElement.style.setProperty('--sidebar-width', val ? '60px' : '220px');
        }
    },
    mounted() {
        document.documentElement.style.setProperty('--sidebar-width', this.sidebarCollapsed ? '60px' : '220px');
    },
    methods: {
        goToDashboard() {
            if (this.$route.path !== '/') {
                this.$router.push('/');
            }
        },
        handleLogout() {
            localStorage.removeItem('super_admin_token');
            window.location.href = '/';
        }
    }
}
</script>

<style scoped>
.sidebar-pill {
    text-decoration: none;
}

/* Ensure all sidebar content sits above the ::before grid overlay */
.glass-sidebar > * {
    position: relative;
    z-index: 1;
}

/* ===== Bottom bar: logout + collapse toggle ===== */
.sidebar-bottom-bar {
    margin-top: auto;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.4rem;
}

.sidebar-bottom-bar .logout-btn {
    flex: 1;
    margin-top: 0;
    border-top: none;
    padding: 0.55rem 0.6rem;
    min-width: 0;
    justify-content: center;
    font-size: 0.85rem;
}

/* Collapse toggle button */
.collapse-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    background: rgba(255, 255, 255, 0.07);
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    transition: all 0.2s;
}

.collapse-btn:hover {
    background: rgba(0, 113, 197, 0.3);
    color: #fff;
    border-color: rgba(0, 113, 197, 0.5);
}

/* Collapsed state — center icons, hide text overflow */
.glass-sidebar.collapsed .sidebar-pill {
    justify-content: center;
    padding: 0.75rem 0;
}

.glass-sidebar.collapsed .sidebar-bottom-bar {
    flex-direction: column;
    gap: 0.4rem;
}

.glass-sidebar.collapsed .sidebar-bottom-bar .logout-btn {
    flex: none;
    width: 100%;
}
</style>
